<template>
	<div style="display: grid; gap: 30px; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); align-items: start">
		<DashboardItem title="Top">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="`${item.dispatcher}:${item['truck#']}`"
							v-for="item of listOfDispatchers.best">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.dispatcher_full_name }}</span></a
								>
							</div>
							<div class="truck-number">{{ item.truckNumber }}</div>
							<div>
								<strong>{{ CURRENCY.format(item.average_per_mile_revenue) }}</strong>
							</div>
							<div>{{ item.total_miles ? item.total_miles.toFixed(0) : 0 }}</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>

		<DashboardItem title="Underdogs">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="`${item.dispatcher}:${item['truck#']}`"
							v-for="item of listOfDispatchers.worst">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.dispatcher_full_name }}</span></a
								>
							</div>
							<div class="truck-number">{{ item.truckNumber }}</div>
							<div>
								<strong>{{ CURRENCY.format(item.average_per_mile_revenue) }}</strong>
							</div>
							<div>{{ item.total_miles ? item.total_miles.toFixed(0) : 0 }}</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>
	</div>
</template>

<script>
import DashboardItem from "../DashboardItem.vue";

export default {
	components: {
		DashboardItem,
	},
	props: ["stats"],
	data: {
		sortOption: "avg",
	},
	computed: {
		listOfDispatchers() {
			try {
				const arr = JSON.parse(JSON.stringify(this.stats.all)).sort((a, b) => b.average_per_mile_revenue - a.average_per_mile_revenue);

				const middleIndex = Math.floor(arr.length / 2);
				const firstHalf = arr.slice(0, middleIndex);

				const secondHalf = arr.slice(middleIndex);
				secondHalf.sort((a, b) => a.average_per_mile_revenue - b.average_per_mile_revenue);

				return { best: firstHalf.slice(0, 10), worst: secondHalf.slice(0, 10) };
			} catch (e) {
				return { best: [], worst: [] };
			}
		},

		tableHeader() {
			return (
				[{ name: "Dispatcher" }, { name: "Truck" }]
					// .concat(this.weeksTableHeader)
					.concat([{ name: "Average" }, { name: "Total Miles" }])
			);
		},
		tableSizes() {
			return (
				["minmax(0, 1fr)", "minmax(100px, 150px)"]
					// .concat(this.weeks.map((item) => "minmax(0, 1fr)"))
					.concat(["minmax(100px, 150px)", "100px"])
			);
		},
	},
};
</script>

<style lang="scss" scoped></style>
